<template>
	<div class="order">
		<div class="title">Ordreoversigt</div>

		<itemsMobile v-if="$res.xsmall()" v-bind="{orderlist: true}"/>
		<items v-else v-bind="{products, type}"/>

		<sum v-bind="data"/>
	</div>
</template>

<script>
import itemsMobile from "@/components/cart-mini/items";
import items from "./items";
import sum from "./sum.vue";

export default {
	components: {items, sum, itemsMobile},
	props: {
		data: {type: Object, required: true},
		type: {type: String, required: true},
		products: {type: Array, required: true}
	}
};
</script>

<style lang="scss" scoped>
.order {
	margin-top: 120px;
	padding-bottom: 8em;

	@include res(xsmall) {
		margin-top: 0;
	}

	.title {
		font-family: $fontMinion;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 26px;

		@include res(xsmall) {
			font-size: 16px;
			padding-bottom: 6px;
			border-bottom: 1px solid #272727;
			margin-top: 26px;
		}
	}
}
</style>
